import React from 'react';

import './index.css';

class SettingContainer extends React.Component {
	render() {
		const { title, theme } = this.props;

		let themeClass = '';

		switch(theme) {
			case 'danger':
				themeClass = ' setting-container-danger';
				break;
			case 'minimal':
				themeClass = ' setting-container-minimal';
				break;	
			default:
				break;	
		}


		return (
			<div
				className={`setting-container${themeClass}`}
			>
				<h4>{title}</h4>
				{this.props.children}
			</div>
		);
	}
}

export default SettingContainer;